import { Navigate } from 'react-router-dom'
import { Formik } from 'formik'

import { AccountForm } from '../common/account-profile-form/account-form.component'
import { useAccountCreateCheck, useAddAccount, useMe, useUser } from 'src/hooks'

import { accountProfileSchema } from 'src/common/validations'
import { initialFormState } from '../common/account-profile-form/form/state.form'
import { AppEvents, ROUTES } from 'src/constants'
import { joinAbsRoute } from 'src/common/utils'
import { EUserRoles, IAccountFormCreate } from 'src/types'

const AddAccountForm = () => {
  const { mutateAsync: addAccount, isLoading, isSuccess } = useAddAccount()
  const { mutateAsync, data: checkData } = useAccountCreateCheck()
  const { data: user } = useUser()
  const { data: userData } = useMe()

  const disabledSubmit = !(
    user?.roles.includes(EUserRoles.superadmin) ||
    (userData?.customer && userData?.accounts?.length === 0)
  )
  if (isSuccess) {
    return <Navigate to={joinAbsRoute(ROUTES.ACCOUNTS)} />
  }

  const handleSubmit = async (values: IAccountFormCreate) => {
    if (disabledSubmit) return

    if (!checkData) {
      const resp = await mutateAsync({
        account_holder: values.account_holder,
        gln: values.gln,
        website: values.website,
      })

      if (resp) {
        const detail = { message: resp.existMessage }

        const event = new CustomEvent(AppEvents.HTTP_WARNING, { detail })
        document.dispatchEvent(event)
        return
      }
    }

    await addAccount(values)
  }

  return (
    <Formik
      initialValues={initialFormState}
      validationSchema={accountProfileSchema}
      validateOnBlur={false}
      onSubmit={handleSubmit}
    >
      <AccountForm
        disabledSubmit={disabledSubmit}
        checkData={checkData}
        isAddingNew
        isLoading={isLoading}
      />
    </Formik>
  )
}

export { AddAccountForm }
